export default __webpack_public_path__ + "23e8c859acca4ca872bd42b5eb565d30.svg";